/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  ClientDto,
  GetClientParams,
  ListClientsParams,
  PaginatedClientDto,
  UpdateClientRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getGetClientUrl = (id: string, params?: GetClientParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/sales/clients/${id}?${stringifiedParams}`
    : `/api/v1/sales/clients/${id}`;
};

/**
 * @summary Get client
 */
export const getClient = async (
  id: string,
  params?: GetClientParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ClientDto> => {
  return customFetch<ClientDto>(getGetClientUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateClientUrl = (id: string) => {
  return `/api/v1/sales/clients/${id}`;
};

/**
 * @summary Update client
 */
export const updateClient = async (
  id: string,
  updateClientRequest: UpdateClientRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateClientUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateClientRequest),
  });
};

export const getDeleteClientUrl = (id: string) => {
  return `/api/v1/sales/clients/${id}`;
};

/**
 * @summary Delete client
 */
export const deleteClient = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteClientUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getListClientsUrl = (params: ListClientsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["countryCodes", "environments"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/sales/clients?${stringifiedParams}`
    : `/api/v1/sales/clients`;
};

/**
 * @summary List clients
 */
export const listClients = async (
  params: ListClientsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedClientDto> => {
  return customFetch<PaginatedClientDto>(getListClientsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getRestoreClientUrl = (id: string) => {
  return `/api/v1/sales/clients/${id}/restore`;
};

/**
 * @summary Restore client
 */
export const restoreClient = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreClientUrl(id), {
    ...options,
    method: "POST",
  });
};
